import { colors as t } from "../../foundations/colors.es.js";
import "../../foundations/shadows.es.js";
import { b as r, c as i, d as e } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: n, definePartsStyle: a } = i([
  "button",
  "content",
  "debugger",
  "divider",
  "editable",
  "editor",
  "linkPopover",
  "placeholder",
  "popover",
  "toolbar"
]), o = r("editor-outline"), l = e({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 8,
  height: 8,
  borderRadius: "md",
  color: "primary.700",
  ":hover": {
    backgroundColor: "primary.100"
  },
  ":active": {
    backgroundColor: "primary.200"
  },
  svg: {
    color: "primary.700"
  }
}), d = e({
  position: "relative"
}), p = e({
  background: "primary.800",
  color: "white",
  display: "block",
  fontSize: "xs",
  lineHeight: "14px",
  maxHeight: "250px",
  overflow: "auto",
  padding: 4,
  position: "relative",
  whiteSpace: "pre-wrap"
}), s = e({
  position: "relative",
  width: 4,
  height: 8,
  "::before": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "block",
    width: "1px",
    height: 4,
    backgroundColor: "primary.100",
    content: '""'
  }
}), c = e({
  overflow: "auto",
  minHeight: "150px",
  resize: "none",
  fontSize: "md",
  position: "relative",
  tabSize: 1,
  outline: 0,
  paddingX: 4,
  marginTop: 4,
  a: {
    color: "link.default",
    textDecoration: "underline"
  },
  "ul, ol": {
    marginLeft: 4
  }
}), b = e({
  [o.variable]: "colors.secondary.50",
  overflow: "hidden",
  width: "100%",
  borderColor: "primary.100",
  borderWidth: 1,
  borderStyle: "solid",
  borderRadius: "md",
  "&:hover": {
    borderColor: "primary.300",
    boxShadow: `0 0 0 4px ${t.primary[50]}`
  },
  ":focus-within": {
    borderColor: "secondary.500",
    boxShadow: `0 0 0 4px ${o.reference}`
  }
}), g = e({
  display: "flex",
  alignItems: "center",
  paddingX: 1,
  input: {
    flex: 1,
    height: 10,
    paddingX: 1,
    color: "primary.700",
    fontWeight: 400,
    "&:focus": {
      outline: "none"
    }
  }
}), h = e({
  position: "absolute",
  top: 0,
  left: 0,
  paddingX: 4,
  color: "primary.500",
  fontSize: "md",
  pointerEvents: "none"
}), y = e({
  position: "absolute",
  zIndex: 100,
  top: "-10000px",
  left: "-10000px",
  maxWidth: "264px",
  height: 10,
  width: "100%",
  opacity: 0,
  marginTop: "-6px",
  backgroundColor: "white",
  boxShadow: "100",
  borderRadius: "md",
  '&[data-placement="top-start"]::before': {
    position: "absolute",
    top: "100%",
    left: 4,
    width: "0px",
    height: "0px",
    borderStyle: "solid",
    borderWidth: "6px 6px 0 6px",
    borderColor: "#FFFFFF transparent transparent transparent",
    transform: "rotate(0deg)",
    content: '""'
  }
}), m = e({
  display: "flex",
  alignItems: "center",
  backgroundColor: "primary.50",
  padding: 1
}), u = a({
  button: l,
  content: d,
  debugger: p,
  divider: s,
  editable: c,
  editor: b,
  linkPopover: g,
  placeholder: h,
  popover: y,
  toolbar: m
}), v = n({
  baseStyle: u
});
export {
  v as Editor
};
//# sourceMappingURL=Editor.es.js.map
